import { createAction, props } from '@ngrx/store';
import {
  SportCenterInfo,
  AddressInfo,
  OwnerCenterInfo,
  AthleteInfo,
  UserInfo,
} from '@libs/entity-lib';
import { State } from './profile.reducer';

export interface AddressState {
  name: string;
  uf: string;
}

export const setInitAthleteState = createAction(
  '[ATHLETE] Set Sport Center Info',
  props<{ newState: State }>()
);

export const setSportCenter = createAction(
  '[ATHLETE] Set Sport Center Info',
  props<{ sportCenter: SportCenterInfo }>()
);

export const setAddressInfo = createAction(
  '[ATHLETE] Set Address Info',
  props<{ addressInfo: AddressInfo }>()
);

export const setOwnerInfo = createAction(
  '[ATHLETE] Set Owner Info',
  props<{ ownerCenterInfo: OwnerCenterInfo }>()
);

export const setAthleteInfo = createAction(
  '[ATHLETE] Set Athlete Info',
  props<{ athleteInfo: AthleteInfo }>()
);

export const registerProfile = createAction(
  '[ATHLETE] Register Profile',
  props<{ profileState: any }>()
);

export const registerProfileSuccefully = createAction(
  '[ATHLETE] Register Profile Succefully',
  props<{ newState: State }>()
);

export const registerProfileFailed = createAction(
  '[ATHLETE] Register Profile Failed',
  props<{ error: any }>()
);

export const setLoading = createAction('[ATHLETE] Set Loading', props<{ loading: boolean }>());

export const verifyEmail = createAction('[ATHLETE] Verify Email', props<{ email: string }>());

export const verifyEmailSuccefully = createAction(
  '[ATHLETE] Verify Email Successfuly ',
  props<{ isEmailValid: boolean }>()
);

export const verifyEmailFailed = createAction(
  '[ATHLETE] Verify Email Failed',
  props<{ error: any }>()
);

export const resetStore = createAction('[ATHLETE] Reset Store');

export const setUserInfo = createAction('[ATHLETE] Set User Info', props<{ userInfo: UserInfo }>());

export const verifyUserName = createAction(
  '[ATHLETE] Verify User Name',
  props<{ userName: string }>()
);

export const verifyUserNameSuccefully = createAction(
  '[ATHLETE] Verify User Name Successfuly ',
  props<{ isUserNameValid: boolean }>()
);

export const verifyUserNameFailed = createAction(
  '[ATHLETE] Verify User Name Failed',
  props<{ error: any }>()
);
